/**
* Custom Select
*/
class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom-dropdown');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', ()=> {
      Utility.toggleElement(this.selectContainer, 'close')
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    _this.closest('.custom-dropdown').classList.add('selected');
    Utility.toggleElement(this.selectContainer, 'close');
    setTimeout(() => {
      this.initOption.querySelector('.option_txt').textContent = _this.querySelector('.option_txt').textContent;
    }, 500);
  }

  /**
   * Hide/Show of custom select option
   * @param _event 
   */
    manageVisibility(_event){
      let isOpen = this.selectContainer.classList.contains('open');
      isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
    }
}
customElements.define('custom-select', customSelect);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
}
customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if(this.toggleBtn) this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    event.preventDefault();
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Show panel content
   */
   showContent() {
    this.toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(this.element, 'open');
    Utility.trapFocus(this.element);

    if(this.element.dataset.behaviour == 'single'){
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach(element => {
        if(element == this.element){ return; }
        element.querySelector('.panel_toggle').click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    collapsibleElements.forEach((ele) => {
      new collapsiblePanel(ele);
    });
  }
}
collapsiblePanel.init();
  

  
  